import httpClient from "./httpClient";

export function login(username, password) {
  return httpClient.post("/auth/login", { username, password }).then((res) => res.data.data);
}

export function fetchCurrentUser() {
  return httpClient.get("/auth/me").then((res) => res.data.data);
}

export function logout() {
  return httpClient.post("/auth/logout").then((res) => res.data.data);
}
